import {
    Home,
    Circle,
    Folder,
    Users,
    BarChart2,
    ShoppingCart,
    Activity,
    List,
    Plus,
    MessageCircle,
    User, DollarSign, Lock
} from 'react-feather'

export default [
    {
        id: 'admin',
        action: 'manage',
        title: 'Admin',
        icon: <Lock size={12}/>,
        children: [
            {
                id: 'users',
                title: 'menu_admin_users',
                action: 'manage',
                navLink: '/admin/users'
            },
            {
                id: 'admin-report-feed',
                title: 'menu_admin_reportFeed',
                action: 'manage',
                navLink: '/admin/reportFeed'
            },
            {
                id: 'admin-banners',
                title: 'menu_admin_banners',
                action: 'manage',
                navLink: '/admin/banners'
            },
            {
                id: 'admin-tournaments',
                action: 'manage',
                title: 'menu_admin_tournaments',
                navLink: '/admin/tournaments'
            },
            {
                id: 'ranks',
                title: 'menu_admin_ranks',
                action: 'manage',
                navLink: '/admin/ranks'
            },
            {
                id: 'admin-approve-custom-bets-settlement',
                title: 'menu_admin_approveCustomBetsSettlement',
                action: 'manage',
                navLink: '/admin/approveCustomBetsSettlement'
            }
        ]
    }
]
